import { css } from '@emotion/core'

/**
 * The wooden tabletop the whole experience sits on.
 *
 * One definition rather than three: the scatter surface, the empty state and the
 * error state all have to paint it. The error state in particular cannot go
 * without - ErrorFallback's `onDarkSurface` switches its copy to white and paints
 * no background of its own, so the brown is what makes that text readable.
 */
export const TABLETOP_BACKGROUND = '#6b4b2f'
export const TABLETOP_COPY = '#fdfcf7'

export const tabletopCss = css`
  background-color: ${TABLETOP_BACKGROUND};
  background-image:
    repeating-linear-gradient(90deg, rgba(0, 0, 0, 0.06) 0 2px, transparent 2px 28px),
    linear-gradient(180deg, rgba(255, 255, 255, 0.06), rgba(0, 0, 0, 0.18));
`
